'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MeetingPrompt = undefined;

var _Promptable = require('UIComponents/decorators/Promptable');

var _Promptable2 = _interopRequireDefault(_Promptable);

var _MeetingModal = require('ui-addon-upgrades/_core/communicationMethods/MeetingModal');

var _MeetingModal2 = _interopRequireDefault(_MeetingModal);

var _PromiseHandlers = require('UIComponents/core/PromiseHandlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _prompt = (0, _Promptable2.default)(_MeetingModal2.default);

var MeetingPrompt = exports.MeetingPrompt = function MeetingPrompt(propsToPass) {
  return _prompt(propsToPass).catch(_PromiseHandlers.rethrowError);
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/communicationMethods/MeetingPrompt.js
// module id = 299
// module chunks = 3 4 5